import { TrafficConeIcon } from 'lucide-react';

export const BackofficeUserAccount = () => {
  return (
    <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
      <TrafficConeIcon size={72} />
      <h1 className="text-4xl font-bold leading-tight">Coming Soon</h1>
      <p className="text-center text-muted-foreground">
        Esta página ainda se encontra em desenvolvimento.
      </p>
    </div>
  );
};
